import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitRsvp = async (payload) => {
  const { data } = await axios.post(`${API}/rsvp`, payload);
  return data;
};

export const verifyAdmin = async (token) => {
  await axios.post(
    `${API}/admin/verify`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
  return true;
};

export const listRsvps = async (token) => {
  const { data } = await axios.get(`${API}/rsvp`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const listTrashedRsvps = async (token) => {
  const { data } = await axios.get(`${API}/rsvp/trash`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const softDeleteRsvp = async (token, id) => {
  await axios.delete(`${API}/rsvp/${id}`, {
    headers: { "X-Admin-Token": token },
  });
};

export const restoreRsvp = async (token, id) => {
  await axios.post(
    `${API}/rsvp/${id}/restore`,
    {},
    { headers: { "X-Admin-Token": token } }
  );
};

export const permanentDeleteRsvp = async (token, id) => {
  await axios.delete(`${API}/rsvp/${id}/permanent`, {
    headers: { "X-Admin-Token": token },
  });
};

export const getRsvpStats = async (token) => {
  const { data } = await axios.get(`${API}/rsvp/stats`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const downloadRsvpXlsx = async (token) => {
  const res = await axios.get(`${API}/rsvp/export`, {
    headers: { "X-Admin-Token": token },
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] || "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match ? match[1] : "rsvp_natanael_raluka.xlsx";
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
